export default __webpack_public_path__ + "static/media/330_dummy2016-tennisclub01-mobile-de.c2f15fc4.png";